module.exports = __webpack_public_path__ + "static/media/ehealthpro_noti_center_slider_phone1.f039cfb9.png";